import { ApiKeyNameStepContent } from "./ApiKeyNameStepContent";
import { ApiKeyResultStepContent } from "./ApiKeyResultStepContent";
import { GetApiKeyStepsArgs } from "./types";

import { StepT, StepType } from "@/components/Stepper/Step/types";

export const getApiKeySteps = ({
  keyName,
  loading,
  activeWorkspaceName,
  apiKey,
  isCopied,
  language,
  codeBlock,
  onKeyNameChange,
  onGenerate,
  onCopyKey,
  onLanguageChange,
}: GetApiKeyStepsArgs): StepT[] => [
  {
    id: "api_key_name",
    title: "Generate New API Key",
    description: "Optionally name this API key before generating it.",
    type: StepType.CUSTOM_STEP,
    ignoreValidation: true,
    isNextDisabled: loading,
    getCustomContent: () => (
      <ApiKeyNameStepContent
        keyName={keyName}
        onKeyNameChange={onKeyNameChange}
        onSubmit={onGenerate}
      />
    ),
  },
  {
    id: "api_key_result",
    title: "Your PromptLayer API Key",
    description:
      "You will only see this API Key once. Make sure to save it somewhere safe. If you lose it, you can generate a new one by clicking on the user icon on the top left.",
    type: StepType.CUSTOM_STEP,
    ignoreValidation: true,
    getCustomContent: () => (
      <ApiKeyResultStepContent
        activeWorkspaceName={activeWorkspaceName}
        apiKey={apiKey}
        isCopied={isCopied}
        language={language}
        onCopyKey={onCopyKey}
        onLanguageChange={onLanguageChange}
        codeBlock={codeBlock}
      />
    ),
  },
];
